import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetTerminals } from "./api/queries/useTerminals";

export const useGetSellmodeAssignedTerminal = ({
  isFetchTerminals = true,
  providers = ["OPAY", "INTERSWITCH", "MONIEPOINT", "KUDA"],
}) => {
  const { store_id } = useParams();
  const STORAGE_KEY = `--assignStoreProviderTerminal--${store_id}`;

  const { isLoading: isFetchingTerminals, data } = useGetTerminals({
    queries: `?store_id=${store_id}`,
    isEnabled: isFetchTerminals,
  });
  const terminals = data?.data || [];

  // Safely parse JSON from localStorage
  const getStoredAssignedTerminals = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (err) {
      localStorage.removeItem(STORAGE_KEY);
      return [];
    }
  };

  const [assignedTerminal, setAssignedTerminal] = useState(
    getStoredAssignedTerminals(),
  );

  const getAssignTerminalProviders = () => {
    const providersObject = {};

    providers?.forEach((provider) => {
      let terminal = null;
      const assignTerminalId = assignedTerminal?.[provider];
      if (assignTerminalId) {
        terminal = terminals?.find(
          (terminal) => `${terminal.id}` === `${assignTerminalId}`,
        );
      } else {
        terminal = terminals?.find(
          (terminal) => terminal?.terminal_type === `${provider}`,
        );
      }

      providersObject[provider] = terminal || null;
    });

    return providersObject;
  };

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(assignedTerminal));
  }, [assignedTerminal]);

  return {
    assignTerminalProviders: getAssignTerminalProviders(),
    isFetchingTerminals,
    terminals,
    assignedTerminal,
    setAssignedTerminal,
  };
};
